import { CarouselNavControls } from './CarouselNavControls'
import { TextStyle } from '../typography'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.sass'
export class Carousel extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    heading: PropTypes.shape({
      title: PropTypes.string,
      titleClassName: PropTypes.string,
      uppercase: PropTypes.bool,
      variant: PropTypes.string,
      actionElement: PropTypes.node,
    }),
    hideArrows: PropTypes.bool,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
    setCarouselOverflow: PropTypes.func.isRequired,
  }

  static defaultProps = {
    heading: null,
    hideArrows: false,
  }

  constructor(props) {
    super(props)
    this.carouselRef = React.createRef()
  }

  componentDidMount() {
    setTimeout(() => {
      this.checkCarouselOverflow()
    }, 500)

    window.addEventListener('resize', this.checkCarouselOverflow)
    this.hideScrollbars()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkCarouselOverflow)
  }

  checkCarouselOverflow = () => {
    if (this.carouselRef.current) {
      const element = this.carouselRef.current

      // Only enable overflow if there's significant scrollable width (50px threshold)
      const hasSignificantOverflow =
        element.scrollWidth - element.clientWidth > 50

      const hasOverflowLeft = hasSignificantOverflow && element.scrollLeft > 0
      const hasOverflowRight =
        hasSignificantOverflow &&
        element.scrollLeft < element.scrollWidth - element.clientWidth

      this.props.setCarouselOverflow(hasOverflowLeft, hasOverflowRight)
    }
  }

  handleCarouselScroll = direction => {
    if (!this.carouselRef.current) return

    const container = this.carouselRef.current
    const containerWidth = container.clientWidth
    const scrollAmount = containerWidth * 0.8 // Scroll 80% of the visible width

    if (direction === 'left') {
      container.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth',
      })
    } else {
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      })
    }
  }

  hideScrollbars = () => {
    const carousel = this.carouselRef.current

    if (carousel) {
      carousel.style.scrollbarWidth = 'none'
      carousel.style.msOverflowStyle = 'none'

      const styleSheet = document.createElement('style')
      styleSheet.textContent = `
          #${carousel.id}::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            display: none !important;
          }
        `
      document.head.appendChild(styleSheet)
    }
  }

  renderHeading() {
    const { heading, hideArrows } = this.props
    const { carouselOverflow } = this.state

    if (!heading || !heading.title) return null

    const {
      title,
      titleClassName,
      uppercase = true,
      variant = 'extra-bold',
      actionElement,
    } = heading

    const showNavigation = !hideArrows && carouselOverflow

    return (
      <div className={styles.headingCarouselHeader}>
        <div className={styles.headingCarouselTitle}>
          <TextStyle
            className={titleClassName}
            uppercase={uppercase}
            variant={variant}
          >
            {title}
          </TextStyle>
        </div>

        {showNavigation && (
          <CarouselNavControls
            inactiveLeft={!this.state.carouselOverflow?.left}
            inactiveRight={!this.state.carouselOverflow?.right}
            onNext={() => this.handleCarouselScroll('right')}
            onPrev={() => this.handleCarouselScroll('left')}
          />
        )}

        {actionElement && (
          <div className={styles.headingCarouselAction}>{actionElement}</div>
        )}
      </div>
    )
  }

  render() {
    const { items, renderItem } = this.props

    return (
      <div className={styles.carouselWrapper}>
        <div className={styles.carouselContainer}>
          <div
            className={classNames(styles.carousel, this.props.className)}
            onScroll={this.checkCarouselOverflow}
            ref={this.carouselRef}
          >
            {items.map(renderItem)}
          </div>
        </div>
      </div>
    )
  }
}
